import { nonEmptyString } from 'schemas/common';
import { z } from 'zod';

export const sourceInstitutionSchema = z.object({
  ID: nonEmptyString,
  country: nonEmptyString,
  name: nonEmptyString,
});

export const selectedSourceInstitutionSchema = nonEmptyString;

export const recentSourceInstitutionSchema = nonEmptyString;

export const recentSourceInstitutionListSchema = z.array(recentSourceInstitutionSchema);
